import { PatientsContent } from "./patients/PatientsContent";

interface PatientsTabProps {
  onSchedule?: (processId: string) => void;
}

export const PatientsTab = ({ onSchedule }: PatientsTabProps) => {
  return <PatientsContent onSchedule={onSchedule} />;
};
